import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";
import { getApiError } from "@/lib/api";

const Signup = () => {
  const { t } = useLang();
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(name, email, password);
      toast.success("OK");
      navigate("/valutazione");
    } catch (err) {
      toast.error(getApiError(err, t.auth.error_signup));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="signup-page" className="min-h-[calc(100vh-64px)] bg-grid">
      <div className="max-w-md mx-auto px-6 py-20">
        <span className="overline text-[#002FA7]">AUTH / SIGNUP</span>
        <h1 className="font-display font-black text-5xl tracking-tighter mt-2">{t.auth.signup_title}</h1>

        <form onSubmit={submit} className="mt-10 bg-white border border-black p-8 shadow-hard space-y-5">
          <div>
            <label className="label-rv">{t.auth.name}</label>
            <input data-testid="signup-name" required value={name} onChange={(e) => setName(e.target.value)} className="input-rv" />
          </div>
          <div>
            <label className="label-rv">{t.auth.email}</label>
            <input data-testid="signup-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-rv" />
          </div>
          <div>
            <label className="label-rv">{t.auth.password}</label>
            <input data-testid="signup-password" type="password" minLength={8} required value={password} onChange={(e) => setPassword(e.target.value)} className="input-rv" />
          </div>
          <button data-testid="signup-submit" type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? "..." : t.auth.submit_signup}
          </button>
          <p className="text-sm text-[#4A4A4A] text-center">
            {t.auth.have_account} <Link to="/login" className="font-bold underline">{t.auth.go_login}</Link>
          </p>
        </form>
      </div>
    </main>
  );
};

export default Signup;
